// extracted by mini-css-extract-plugin
module.exports = {"avatar":"ActiveServerView_avatar__3ykIO","account":"ActiveServerView_account__3wYG9","activeservers":"ActiveServerView_activeservers__35OuH"};